import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { useLinkButtonProps } from 'shared/hooks';
import { TwinBanner } from './components/TwinBanner';
import { UTP } from './constants';
import * as styles from './styles.css';
import { LK_MY_OFFERS_LINK } from 'shared/constants/links';
import { clsx } from 'clsx';

export const AutoStrategiesBanner: React.FC = () => {
  const linkButtonProps = useLinkButtonProps();
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Получите больше эффективности с обновленными автостратегиями</div>
      <div className={styles['list']}>
        {UTP.map(item => (
          <div className={styles['list-item']} key={item.title}>
            <div className={styles['item-title']}>{item.title}</div>
            <div className={styles['item-description']}>{item.description}</div>
          </div>
        ))}
      </div>
      <TwinBanner />
      <div className={styles['btn']}>
        <LinkButton {...linkButtonProps} href={LK_MY_OFFERS_LINK}>
          Подключить автостратегию
        </LinkButton>
      </div>
    </div>
  );
};
